<template>
    <o-intro></o-intro>
</template>

<script>
import "./intro"

export default {};
</script>
